import { IElixirState } from '@elixir/fx';
import { IRootState } from '.';
import { Module } from './constants';

export const businessReviewSelector = (state: IElixirState): IRootState =>
  state.modules[Module.BusinessReview] as IRootState;
